import React, { useState, useEffect } from 'react';
import { API_ENDPOINTS } from '../../../api';
import { deleteService, postService } from '../../../servce/ApisService';
// import { PostManagementDto } from "../../../api/interfaces/PostManagementDto";
import { useLocation } from 'react-router-dom';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { PostDto } from '../../../api/interfaces/Posts';
import { getServiceyName } from '../../../utility/RolesUtility';
import { useLoader } from '../../../Loader/LoaderContext';
import { useToaster } from '../../../Toaster/Toaster';
import Sucesspopup from '../Modals/SucessPopup';
interface PostManagementDto extends PostDto {
  // Optional properties or additional properties specific to PostManagementDto
}

const ItemType = 'POST';
const tabKeyMapping: Record<string, string> = {
  'What’s Hot': 'WHAT_S_HOT',
  'Trending Now': 'TRENDING_NEWS_NOW',
  'Top News': 'TOP_NEWS',
  'Most Read': 'MOST_READ',
  'Featured Articles': 'FEATURED_ARTICLES',
  'Insights of the Week': 'INSIGHTS_OF_THE_WEEK',
  'Latest Stories': 'LATEST_STORIES',
  'Industry Trends': 'INDUSTRY_TRENDS',
  'Popular Reads': 'POPULAR_READS',
  'Featured Reports': 'FEATURED_REPORTS',
  'Market Insights': 'MARKET_INSIGHTS',
  'Latest Research': 'LATEST_RESEARCH',
  'Top Picks': 'TOP_PICKS',
  'Featured White Papers': 'FEATURED_WHITE_PAPERS',
  'Deep Insights': 'DEEP_INSIGHTS',
  'Latest Additions': 'LATEST_ADDITIONS',
  'Trending Topics': 'TRENDING_WHITE_PAPERS_TOPICS',
  'Featured Conversations': 'FEATURED_CONVERSATIONS',
  'Latest Interviews': 'LATEST_INTERVIEWS',
  'Featured Webinars': 'FEATURED_WEBINARS',
  'Latest Webinars': 'LATEST_WEBINARS',
  'Featured Videos': 'FEATURED_VIDEOS',
  'Latest Videos': 'LATEST_VIDEOS',
  'Featured Events': 'FEATURED_EVENTS',
  'Popular Events': 'POPULAR_EVENTS',
};
const tabKeyMap: Record<string, null | any> = {
  'What’s Hot': 'WHAT_S_HOT',
  'Trending Now': 'TRENDING_NEWS_NOW',
  'Top News': 'TOP_NEWS',
  'Most Read': null,
  'Featured Articles': 'FEATURED_ARTICLES',
  'Insights of the Week': 'INSIGHTS_OF_THE_WEEK',
  'Latest Stories': 'LATEST_STORIES',
  'Industry Trends': 'INDUSTRY_TRENDS',
  'Popular Reads': null,
  'Featured Reports': 'FEATURED_REPORTS',
  'Market Insights': 'MARKET_INSIGHTS',
  'Latest Research': null,
  'Top Picks': 'TOP_PICKS',
  'Featured White Papers': 'FEATURED_WHITE_PAPERS',
  'Deep Insights': 'DEEP_INSIGHTS',
  'Latest Additions': null,
  'Trending Topics': 'TRENDING_WHITE_PAPERS_TOPICS',
  'Featured Conversations': 'FEATURED_CONVERSATIONS',
  'Latest Interviews': null,
  'Featured Webinars': 'FEATURED_WEBINARS',
  'Latest Webinars': null,
  'Featured Videos': 'FEATURED_VIDEOS',
  'Latest Videos': null,
};
const DraggableItem = ({
  item,
  index,
  moveItem,
  setData,
  fetchDetails,
  activeTab,
}: {
  item: PostDto;
  index: number;
  moveItem: (dragIndex: number, hoverIndex: number) => void;
  setData: React.Dispatch<React.SetStateAction<PostDto[]>>;
  fetchDetails: () => void;
  activeTab: string;
}) => {
  const [isDragging, ref] = useDrag({
    type: ItemType,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  console.log('item', item);
  const [, drop] = useDrop({
    accept: ItemType,
    hover: (draggedItem: { index: number }) => {
      if (draggedItem.index !== index) {
        moveItem(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });
  const { setLoading } = useLoader();
  const { showToast } = useToaster();
  // const [activeTab, setActiveTab] = useState("What’s Hot");
  const deletePost = async (item: PostDto, activeTab: string) => {
    if (item?.selectedFromPostManagment) {
      // Remove item locally if it was added from Post Management
      setData((prevData: PostDto[]) =>
        prevData.filter((dataItem) => dataItem.id !== item.id)
      );
      showToast(
        'Post removed successfully from Post Management!',
        'success',
        ''
      );
    } else {
      try {
        setLoading(true);

        // Handle special cases where tabKeyMap[activeTab] is null
        let postSectionValue: string;

        // Special cases that don't follow the normal mapping
        switch (activeTab) {
          case 'Most Read':
            postSectionValue = 'MOST_READ';
            break;
          case 'Popular Reads':
            postSectionValue = 'POPULAR_READS';
            break;
          case 'Latest Research':
            postSectionValue = 'LATEST_RESEARCH';
            break;
          case 'Latest Additions':
            postSectionValue = 'LATEST_ADDITIONS';
            break;
          case 'Latest Interviews':
            postSectionValue = 'LATEST_INTERVIEWS';
            break;
          case 'Latest Webinars':
            postSectionValue = 'LATEST_WEBINARS';
            break;
          case 'Latest Videos':
            postSectionValue = 'LATEST_VIDEOS';
            break;
          default:
            // For normal cases, use the tabKeyMapping
            postSectionValue = tabKeyMapping[activeTab];
        }

        let response: any;
        response = await deleteService(
          API_ENDPOINTS.deletePostOrder +
            '?postId=' +
            item?.id +
            '&postSection=' +
            postSectionValue
        );

        if (response.statusCode == 200) {
          setData((prevData: PostDto[]) =>
            prevData.filter((dataItem) => dataItem.id !== item.id)
          );
          showToast('Post deleted successfully!', 'success', '');
          fetchDetails();
        }
      } catch (error: any) {
        console.error('Delete error:', error);
        showToast('Failed to delete post', 'error', error.message || '');
      } finally {
        setLoading(false);
      }
    }
  };
  return (
    <div
      ref={(node) => ref(drop(node))}
      key={item.id}
      style={{ cursor: 'grab' }}
      className="bg-white pl-5 py-2.5 cursor-pointer border-b border-[#D1D5DB] flex items-center"
    >
      <div className="flex items-center flex-grow min-w-0">
        <img src="/images/table_checkbox.svg" alt="Checkbox" />
        <p
          className="pl-9 mr-5 w-[95%] text-sm font-semibold overflow-hidden whitespace-nowrap min-w-0"
          style={{ textOverflow: 'ellipsis' }}
        >
          {item.title}
        </p>
      </div>
      <div className="flex items-center min-w-max ml-auto">
        {/* <p className="w-2 h-2 border bg-gray-500 rounded-full"></p>
        <div className="flex items-center justify-start min-w-[165px]">
          <p className="pl-3 text-[#B00A2B] text-sm font-normal">
            {getServiceyName(item.category) || "NA"}
          </p>
        </div> */}
        {item.category && getServiceyName(item.category) !== 'NA' && (
          <>
            <p className="w-2 h-2 border bg-gray-500 rounded-full"></p>
            <div className="flex items-center justify-start min-w-[165px]">
              <p className="pl-3 text-[#B00A2B] text-sm font-normal">
                {getServiceyName(item.category)}
              </p>
            </div>
          </>
        )}

        {/* {item?.isOrderDeletable || item?.selectedFromPostManagment ? ( */}
        <div
          className="flex items-center"
          onClick={() => deletePost(item, activeTab)}
        >
          <img
            src="/images/delete_icon.svg"
            alt="Delete Icon"
            className="mr-6 cursor-pointer"
          />
        </div>
        {/* ) : (
          <div className="w-[40px]"></div>
        )} */}
      </div>
    </div>
  );
};
const Articles = () => {
  const [hasMore, setHasMore] = useState(true);
  const { setLoading } = useLoader();
  const location = useLocation();
  const { showToast } = useToaster();
  const [activeTab, setActiveTab] = useState('What’s Hot');
  const path = location.pathname;
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  // const [responseData, setResponseData] = useState([]);
  // const [datas, setData] = useState([]);
  const [datas, setData] = useState<PostDto[]>([]); // For table data
  const [responseData, setResponseData] = useState<PostManagementDto[]>([]); // For dropdown data
  const [isShow, setIsShow] = useState(false);
  const [name, setName] = useState('');
  const isArticlesRoute =
    location.pathname === '/portals/postManagement/articles';
  const isNewsRoute = location.pathname === '/portals/postManagement/news';
  const isInterviewsRoute =
    location.pathname === '/portals/postManagement/interviews';
  const isWebinarRoute =
    location.pathname === '/portals/postManagement/webinars';
  const isReportRoute = location.pathname === '/portals/postManagement/reports';
  const isWhitePaperRoute =
    location.pathname === '/portals/postManagement/whitePapers';
  const isVideoRoute = location.pathname === '/portals/postManagement/videos';
  const isEventRoute = location.pathname === '/portals/postManagement/events';

  const routeNames: Record<string, string> = {
    '/portals/postManagement/articles': 'Articles',
    '/portals/postManagement/news': 'News',
    '/portals/postManagement/interviews': 'Interviews',
    '/portals/postManagement/webinars': 'Webinars',
    '/portals/postManagement/reports': 'Reports',
    '/portals/postManagement/videos': 'Videos',
    '/portals/postManagement/whitePapers': 'White Papers',
    '/portals/postManagement/events': 'Events',
  };
  const getRouteName = (path: string): string => {
    return routeNames[path] || 'Unknown Route';
  };

  const newsTabs: string[] = [
    'What’s Hot',
    'Trending Now',
    'Top News',
    'Most Read',
  ];
  const articlesTabs: string[] = [
    'Featured Articles',
    'Insights of the Week',
    'Latest Stories',
    'Popular Reads',
    'Industry Trends',
  ];
  const reportsTabs: string[] = [
    'Featured Reports',
    'Market Insights',
    'Latest Research',
    'Top Picks',
  ];
  const whitePapers: string[] = [
    'Featured White Papers',
    'Deep Insights',
    'Latest Additions',
    'Trending Topics',
  ];
  const interviewsTabs: string[] = [
    'Featured Conversations',
    'Latest Interviews',
  ];
  const webinars: string[] = ['Featured Webinars', 'Latest Webinars'];
  const videosTab: string[] = ['Featured Videos', 'Latest Videos'];
  const eventsTab: string[] = ['Featured Events', 'Popular Events'];
  // Fetch data based on the search query
  useEffect(() => {
    fetchDetails();
  }, [searchQuery, activeTab, currentPage]);
  useEffect(() => {
    if (isArticlesRoute) setActiveTab('Featured Articles');
    if (isNewsRoute) setActiveTab('What’s Hot');
    if (isReportRoute) setActiveTab('Featured Reports');
    if (isWebinarRoute) setActiveTab('Featured Webinars');
    if (isWhitePaperRoute) setActiveTab('Featured White Papers');
    if (isVideoRoute) setActiveTab('Featured Videos');
    if (isEventRoute) setActiveTab('Featured Events');
    if (isInterviewsRoute) setActiveTab('Featured Conversations');
  }, [location.pathname]);

  const handleSave = async () => {
    try {
      setLoading(true);
      let postType: any;
      if (path === '/portals/postManagement/news') {
        postType = 'NEWS';
      } else if (path === '/portals/postManagement/articles') {
        postType = 'ARTICLE';
      } else if (path === '/portals/postManagement/interviews') {
        postType = 'INTERVIEW';
      } else if (path === '/portals/postManagement/reports') {
        postType = 'REPORT';
      } else if (path === '/portals/postManagement/webinars') {
        postType = 'WEBINAR';
      } else if (path === '/portals/postManagement/whitePapers') {
        postType = 'WHITE_PAPER';
      } else if (path === '/portals/postManagement/videos') {
        postType = 'VIDEO';
      } else if (path === '/portals/postManagement/events') {
        postType = 'EVENT';
      }
      let url = API_ENDPOINTS.savePostManagement;
      const body = {
        postSection: tabKeyMapping[activeTab], // Value for postSection
        postOrderDtos: datas.map((user: PostDto, index: number) => ({
          id: String(user.id), // Convert id to string (Long on backend)
          orderSeq: String(index + 1), // Convert orderSeq to string (Long on backend)
        })),
      };
      const response = await postService(url, body);
      if (response?.data?.content) {
        if (searchQuery) {
          setResponseData(response.data.content);
        } else {
          setData(response.data.content);
        }
      }
      setSearchQuery('');
      setShowDropdown(true);
      showToast(
        'Post order has been successfully updated and saved!',
        'success',
        ''
      );
      fetchDetails();
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };
  // const fetchDetails = async (name?: string) => {
  //   try {
  //     setLoading(true);
  //     let postType: any;
  //     if (path === '/portals/postManagement/news') {
  //       postType = 'NEWS';
  //     } else if (path === '/portals/postManagement/articles') {
  //       postType = 'ARTICLE';
  //     } else if (path === '/portals/postManagement/interviews') {
  //       postType = 'INTERVIEW';
  //     } else if (path === '/portals/postManagement/reports') {
  //       postType = 'REPORT';
  //     } else if (path === '/portals/postManagement/webinars') {
  //       postType = 'WEBINAR';
  //     } else if (path === '/portals/postManagement/whitePapers') {
  //       postType = 'WHITE_PAPER';
  //     } else if (path === '/portals/postManagement/videos') {
  //       postType = 'VIDEO';
  //     }
  //     let url = API_ENDPOINTS.getPostManagement;
  //     const body = {
  //       search: searchQuery,
  //       postType: postType,
  //       isTableData: searchQuery ? false : true,
  //       postSection: tabKeyMapping[activeTab],
  //       postSectionFilter: tabKeyMapping[activeTab],
  //       page: currentPage,
  //     };
  //     const response = await postService(url, body);
  //     if (response?.data?.content) {
  //       if (searchQuery) {
  //         setResponseData(response.data.content);
  //       } else {
  //         setData((prevData) => {
  //           const combinedData = [...prevData, ...response.data.content];
  //           console.log(combinedData);

  //           return Array.from(
  //             new Map(combinedData.map((item) => [item.id, item])).values()
  //           );
  //         });
  //       }
  //       if (response.data.last) {
  //         setHasMore(false); // No more data to load
  //       } else {
  //         setHasMore(true); // There are more pages
  //       }
  //     }
  //     setShowDropdown(true);
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchDetails = async (name?: string) => {
    try {
      setLoading(true);

      let postType: any;
      if (path === '/portals/postManagement/news') {
        postType = 'NEWS';
      } else if (path === '/portals/postManagement/articles') {
        postType = 'ARTICLE';
      } else if (path === '/portals/postManagement/interviews') {
        postType = 'INTERVIEW';
      } else if (path === '/portals/postManagement/reports') {
        postType = 'REPORT';
      } else if (path === '/portals/postManagement/webinars') {
        postType = 'WEBINAR';
      } else if (path === '/portals/postManagement/whitePapers') {
        postType = 'WHITE_PAPER';
      } else if (path === '/portals/postManagement/videos') {
        postType = 'VIDEO';
      } else if (path === '/portals/postManagement/events') {
        postType = 'EVENT';
      }

      const isFeaturedTab =
        activeTab === 'Featured Videos' ||
        activeTab === 'Featured Webinars' ||
        activeTab === 'Featured Conversations';

      const body = {
        search: searchQuery,
        postType: postType,
        isTableData: searchQuery ? false : true,
        postSection: tabKeyMapping[activeTab],
        postSectionFilter: tabKeyMapping[activeTab],
        page: isFeaturedTab ? 0 : currentPage, // Always 0 for featured
        pageSize: isFeaturedTab ? 7 : undefined, // Only send size when needed
      };

      const url = API_ENDPOINTS.getPostManagement;
      const response = await postService(url, body);

      if (response?.data?.content) {
        if (searchQuery) {
          setResponseData(response.data.content);
        } else {
          setData((prevData) => {
            const combinedData = [...prevData, ...response.data.content];
            return Array.from(
              new Map(combinedData.map((item) => [item.id, item])).values()
            );
          });
        }

        // For non-featured tabs, check if it's the last page
        if (!isFeaturedTab && response.data.last) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      }
      setShowDropdown(true);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setData([]); // Clear table data
    setCurrentPage(0); // Reset pagination
    fetchDetails(); // Fetch new tab data
  }, [activeTab]);
  const handleAddToTable = (
    user: PostManagementDto,
    event: React.MouseEvent
  ) => {
    event.stopPropagation(); // Prevent event propagation to parent elements
    const isFeaturedTab =
      activeTab === 'Featured Videos' ||
      activeTab === 'Featured Webinars' ||
      activeTab === 'Featured Conversations';

    if (isFeaturedTab && datas.length >= 7) {
      setIsShow(true);
      setName('isFeatured');
      return; // Prevent further execution
    }
    if (activeTab === 'Featured Events' && datas.length >= 5) {
      setIsShow(true);
      setName('isEvent');
      return;
    }
    setData((prevData) => {
      // Check if the post already exists in the table
      const isAlreadyAdded = prevData.some((item) => item.id === user.id);

      if (isAlreadyAdded) {
        // Display toaster message if post already exists
        showToast(
          'This post has been already added. It will appear first.',
          'success',
          ''
        );

        // Move the existing post to the beginning of the array
        const updatedData = prevData.filter((item) => item.id !== user.id);
        return [{ ...user, selectedFromPostManagment: true }, ...updatedData];
      }

      // Show success message for a newly added post
      showToast('Post added successfully!', 'success', '');

      // Add the post to the beginning of the table
      return [{ ...user, selectedFromPostManagment: true }, ...prevData];
    });

    // Ensure the dropdown remains open
    setShowDropdown(true);
  };

  useEffect(() => {
    setSearchQuery(''); // Clear search query when tab changes
    setShowDropdown(false); // Optionally hide dropdown when tab changes
  }, [activeTab]);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    setCurrentPage(0);
    if (!showDropdown && event.target.value) {
      setShowDropdown(true); // Open the dropdown when the search query is non-empty
    }
  };
  // const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
  //   console.log('scrollHeight:', event.currentTarget.scrollHeight);
  //   console.log('scrollTop:', event.currentTarget.scrollTop);
  //   console.log('clientHeight:', event.currentTarget.clientHeight);

  //   const tolerance = 5; // Adjust the tolerance as needed
  //   const bottom =
  //     event.currentTarget.scrollHeight -
  //       event.currentTarget.scrollTop -
  //       event.currentTarget.clientHeight <=
  //     tolerance;

  //   if (bottom && hasMore) {
  //     setCurrentPage((prevPage) => prevPage + 1); // Load the next page
  //   }
  // };

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const tolerance = 5;
    const target = event.currentTarget;

    const bottom =
      target.scrollHeight - target.scrollTop - target.clientHeight <= tolerance;

    // Don't load more if it's a featured tab or no more pages
    if (bottom && hasMore) {
      const isFeaturedTab =
        activeTab === 'Featured Videos' ||
        activeTab === 'Featured Webinars' ||
        activeTab === 'Featured Conversations';

      if (!isFeaturedTab) {
        setCurrentPage((prevPage) => prevPage + 1);
      }
    }
  };
  const handleClickOutside = (event: MouseEvent) => {
    if (!(event.target as HTMLElement).closest('.search-container')) {
      setShowDropdown(false);
    }
  };
  const moveItem = (dragIndex: number, hoverIndex: number) => {
    const updatedDatas = [...datas];
    const [draggedItem] = updatedDatas.splice(dragIndex, 1);
    updatedDatas.splice(hoverIndex, 0, draggedItem);
    setData(updatedDatas);
  };
  useEffect(() => {
    document.addEventListener('click', handleClickOutside as EventListener);
    return () => {
      document.removeEventListener(
        'click',
        handleClickOutside as EventListener
      );
    };
  }, []);

  const getCategory: Record<string, string> = {
    IUI: 'IUI',
    IVF: 'IVF',
    HOSPITAL: 'Hospital',
    SURROGACY_CENTER: 'Surrogacy Center',
    ICSI: 'ICSI',
    SPERM_OR_EGG_FREEZING: 'Sperm/ Egg freezing',
  };
  const isPostAlreadyAdded = (postId: number) => {
    return datas.some((data) => data.id === postId);
  };
  interface TabDetails {
    iconActive: string;
    iconDefault: string;
    message: string;
  }

  const tabDetails: Record<string, TabDetails> = {
    'Trending Now': {
      iconActive: '/images/Active_Information circle (1).svg',
      iconDefault: '/images/Information circle.svg',
      message:
        'Posts are displayed in the default order, starting with the most recently posted.',
    },
    'Most Read': {
      iconActive: '/images/Active_Information circle (1).svg',
      iconDefault: '/images/Information circle.svg',
      message:
        'Posts are displayed in the default order, starting with those having the highest viewership.',
    },
    'Latest Stories': {
      iconActive: '/images/Active_Information circle (1).svg',
      iconDefault: '/images/Information circle.svg',
      message:
        'Posts are displayed in default order, starting with the most recently added article.',
    },
    'Popular Reads': {
      iconActive: '/images/Active_Information circle (1).svg',
      iconDefault: '/images/Information circle.svg',
      message: 'Same as most read in news section.',
    },
    'Latest Interviews': {
      iconActive: '/images/Active_Information circle (1).svg',
      iconDefault: '/images/Information circle.svg',
      message:
        'Posts are displayed in default order, starting with the most recently added interview.',
    },
    'Latest Research': {
      iconActive: '/images/Active_Information circle (1).svg',
      iconDefault: '/images/Information circle.svg',
      message:
        'Posts are displayed in default order, starting with the most recently added report.',
    },
    'Latest Additions': {
      iconActive: '/images/Active_Information circle (1).svg',
      iconDefault: '/images/Information circle.svg',
      message:
        'Posts are displayed in default order, starting with the most recently added white papers.',
    },
    'Latest Webinars': {
      iconActive: '/images/Active_Information circle (1).svg',
      iconDefault: '/images/Information circle.svg',
      message:
        'Posts are displayed in default order, starting with the most recently added webinars.',
    },
    'Latest Videos': {
      iconActive: '/images/Active_Information circle (1).svg',
      iconDefault: '/images/Information circle.svg',
      message:
        'Posts are displayed in default order, starting with the most recently added videos.',
    },
  };
  const getTabs = () => {
    if (isArticlesRoute) return articlesTabs;
    if (isNewsRoute) return newsTabs;
    if (isReportRoute) return reportsTabs;
    if (isInterviewsRoute) return interviewsTabs;
    if (isWhitePaperRoute) return whitePapers;
    if (isWebinarRoute) return webinars;
    if (isVideoRoute) return videosTab;
    if (isEventRoute) return eventsTab;
    return [];
  };

  const tabs = getTabs();
  const closePopup = () => {
    setIsShow(false);
  };
  const viewUsers = () => {
    setIsShow(false);
    // navigate("/portals/contentCompanies/viewCompanies");
  };

  return (
    <div className="h-full py-2 w-full">
      <div className="flex items-center cursor-pointer mb-6 font-sans">
        <h2 className="mr-2 text-gray-700 font-semibold text-sm">
          Post Management
        </h2>
        <img src="/images/arrowIcons.svg" className="mr-2" alt="Arrow Icon" />
        <span className="text-gray-400 font-semibold text-sm">
          {getRouteName(location.pathname)}
        </span>
      </div>
      <div className="relative mb-7 border-b-2 border-gray-200 font-Inter">
        <div className="flex gap-7">
          {tabs.map((tab) => (
            <p
              key={tab}
              onClick={() => setActiveTab(tab)} // Change tab on click
              className={`${
                activeTab === tab
                  ? 'font-semibold text-[#B00A2B]'
                  : 'font-medium text-gray-600'
              } cursor-pointer text-base pb-3 flex items-center gap-2 relative`}
            >
              {tab}

              {/* Bottom border to highlight active tab */}
              {activeTab === tab && (
                <span className="absolute left-0 bottom-0 w-full h-0.5 bg-[#B00A2B]"></span>
              )}

              {/* Tooltip Icon with hover message */}
              {tabDetails[tab] && (
                <div
                  className="relative group"
                  onClick={(e) => e.stopPropagation()} // Prevent the click from propagating to the parent tab
                >
                  {/* <img
                    src={
                      activeTab === tab
                        ? tabDetails[tab].iconActive
                        : tabDetails[tab].iconDefault
                    }
                    alt='Information'
                    className={`inline-block w-4 h-4 ml-1 ${
                      activeTab === tab ? 'cursor-pointer' : 'cursor-default'
                    }`}
                  /> */}

                  {/* Tooltip Message on Hover */}
                  <span className="absolute font-Inter font-normal top-full left-1/2 transform -translate-x-1/2 mt-1 w-max bg-black text-white text-xs rounded-md border border-gray-200 py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity">
                    {tabDetails[tab].message}
                    <span
                      className="absolute left-1/2 transform -translate-x-1/2 -top-[5px]"
                      style={{
                        width: 0,
                        height: 0,
                        borderLeft: '6px solid transparent',
                        borderRight: '6px solid transparent',
                        borderBottom: '6px solid black',
                      }}
                    ></span>
                  </span>
                </div>
              )}
            </p>
          ))}
        </div>
      </div>
      {/* Search Bar */}
      <div className="md:flex items-center mb-7 search-container">
        <h1 className="text-2xl whitespace-nowrap font-bold mb-2 text-[#2D2E2F] mr-3 font-sans">
          {activeTab}
        </h1>
        <div className="relative w-full">
          <input
            type="text"
            placeholder="Search for post by Title/ID/Tag"
            className="hidden md:flex p-2 pl-10 border-[#D1D5DB] w-full rounded-md border-2 mr-4 focus:border-[#B00A2B] focus:outline-none"
            onChange={handleSearch}
            value={searchQuery}
          />
          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
            <img src="/images/searchIcon.svg" />
          </span>

          {showDropdown && searchQuery && (
            <div className="absolute left-0 w-full mt-2 bg-white border border-gray-200 rounded-md shadow-lg z-10 font-Inter">
              <ul className="max-h-60 overflow-y-auto">
                {responseData.map((user: PostManagementDto) => (
                  <div
                    key={user.id}
                    className="bg-white pl-4 pr-4 py-2 flex items-center flex-wrap sm:flex-nowrap"
                  >
                    <div className="flex items-center font-medium text-sm flex-grow min-w-0">
                      <p
                        className="mr-5 overflow-hidden whitespace-nowrap text-ellipsis"
                        style={{ textOverflow: 'ellipsis' }}
                      >
                        {user.title}
                      </p>
                    </div>
                    <div className="flex items-center min-w-max ml-auto space-x-4">
                      {user.category &&
                        getServiceyName(user.category) !== 'NA' && (
                          <>
                            <p className="w-2 h-2 border bg-gray-500 rounded-full"></p>
                            <div className="flex items-center justify-start min-w-[165px]">
                              <p className="pl-3 text-[#B00A2B] text-sm font-normal">
                                {getServiceyName(user.category)}
                              </p>
                            </div>
                          </>
                        )}
                      <div className="flex items-center justify-end">
                        <img
                          src="/images/plus_Icon.svg"
                          alt="Plus Icon"
                          className="cursor-pointer"
                          onClick={(e) => handleAddToTable(user, e)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
      {/* Articles List */}
      <div
        className="border border-[#D1D5DB] rounded-md mb-[12px]"
        // onScroll={handleScroll}
      >
        <DndProvider backend={HTML5Backend}>
          <div className="font-sans">
            <div className="bg-[#FFF7F7] pl-5 py-2 border-b border-[#D1D5DB] flex rounded-tr-md rounded-tl-md">
              <p className="pl-14 font-semibold text-base">Title</p>
            </div>

            <div
              className="justify-between scroolCls h-[60vh] overflow-y-scroll"
              onScroll={handleScroll}
            >
              {datas.length > 0 ? (
                <div>
                  {datas.map((user: PostDto, index) => (
                    <DraggableItem
                      key={user.id}
                      item={user}
                      index={index}
                      moveItem={moveItem}
                      setData={setData}
                      fetchDetails={fetchDetails}
                      activeTab={activeTab}
                    />
                  ))}
                </div>
              ) : (
                <div className="text-center py-4 font-semibold text-gray-500">
                  No data to show
                </div>
              )}
            </div>
          </div>
        </DndProvider>
        {/* {!(showDropdown && searchQuery) && ( */}
        <div className="fixed bottom-[10px] w-[78%]">
          <div
            className="flex justify-end mt-4 p-4 items-center bg-white mb-[-10px]"
            style={{
              boxShadow: '0px -16px 50px 0px #0000000D',
            }}
          >
            <button
              type="submit"
              onClick={handleSave}
              // disabled={!isValid || isSubmitting || isBollen}
              className={`px-4 py-2 gradient-background width-[87px] text-white rounded font-bold text-base`}
            >
              Save
            </button>
          </div>
        </div>
        {/* )} */}
      </div>{' '}
      {isShow && (
        <Sucesspopup
          addUser={closePopup}
          viewUser={viewUsers}
          emailId={''}
          name={name}
          // isUpdate={userId ? 'update' : 'add'}
          nameOfScreen="trendingNow"
          // // isApproval={isPublish ? 'approval' : 'draft'}
          // statusValue={submittedData?.status || ''}
          download={function (): void {
            throw new Error('Function not implemented.');
          }}
          upload={function (): void {
            throw new Error('Function not implemented.');
          }}
          confirm={function (): void {
            throw new Error('Function not implemented.');
          }}
        />
      )}
    </div>
  );
};

export default Articles;
